<template>
  <div class="clinic">
    <div class="top">
      <Menu mode="horizontal" ref="slideMenu" :active-name="activeName1">
        <MenuItem :name="p.sn" :to="p.url" v-for="(p,index) in navItems" :key="index">
          <Icon :custom="p.icon" />
          {{p.menuName}}
        </MenuItem>
      </Menu>
    </div>
    <div class="main">
      <div class="leftMain">
        <router-view/>
      </div>
      <div class="rightMain" v-show="isRightMenu">
        <Menu theme="light" width="auto" >
          <Submenu  v-for="(item,index) in navItems1" :key="index" :name="item.sn" >
            <template slot="title">
              <Icon :type="item.icon"></Icon>
              {{item.menuName}}
              ({{item.count}})
            </template>
            <MenuItem v-for="(m,i) in item.children" :key="i" :name="m.sn" :to="m.url" @click.native="changePatient(m.sn,m.hospitalCaseId,item.sn)">
              <span>{{m.name}}</span>
              <span>{{m.mobile}}</span>
              <span>{{m.diagnosis}}</span>
              <span>{{m.diagnosisTime|replaceT}}</span>
            </MenuItem>
          </Submenu>
        </Menu>
        <div class="commonBox">
          <div class="sick">
            <p>常见疾病</p>
            <ul>
              <li :class="{'hight':disease.name==$store.state.sickName}" v-for="(disease,dIndex) in comDisease" :key="dIndex" @click="selectDisease(disease)" :title="disease.name">
                {{disease.name}}
              </li>
            </ul>
          </div>
          <div class="symptom">
            <p>常见症状</p>
            <ul>
              <li :class="{'hight':symptom.isSel}" v-for="(symptom,sIndex) in comSymptom" :key="sIndex" @click="selectSymptom(symptom)" :title="symptom.name">
                {{symptom.name}}
              </li>
            </ul>
          </div>
          <div class="inspection">
            <p>检验项目</p>
            <ul>
              <li :class="{'hight':inspection.isSel}" v-for="(inspection,iIndex) in comInspection" :key="iIndex" @click="selectInspection(inspection,comInspection)" :title="inspection.name">
                {{inspection.name}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import {clinicalList,commonDisease,commonSymptom,expansionPro,historyList} from '../../api/clinic'
import { tips,replaceT } from "../../tools";
export default {
  name: 'Clinic',
  inject: ['reload'],
  data () {
    return {
      isRightMenu:true,
      navItems:[],
      navItems1:[],
      theme2:'light',
      activeName1:'',
      sickItems:[],//疾病集合
      symptom:[],//症状集合
      inspection:[],//检验项目
      comDisease:[],//常用项目集合
      comSymptom:[],//常用症状
      comShowDisease:[],//常用项目展示集合
      comShowSymptom:[],//常用展示症状
      symptomStr:[],// 症状拼接集合
      comInspection:[],//推广项目集合
      inspectStr:[],
    }
  },
  filters:{
    replaceT
  },
  mounted(){
    console.log(this.$store.state);
    console.log(this.$route.path);
    let path = this.$route.path;
    if(path=='/patientlist'){
      this.isRightMenu = false;
    }else{
      this.isRightMenu = true;
    }
    this.getItem()
    this.$nextTick(()=>{
      this.menu = this.navItems[0].sn;
      this.$refs.slideMenu.updateActiveName();
    })
    this.getList(1);
    this.getList(3);
    this.getCommom();
  },
  watch:{
    getPatient(){
      this.historyList(this.getPatient,this.getPhone);
    },
    getPhone(){
      this.historyList(this.getPatient,this.getPhone);
    }
  },
  computed:{
    ...mapGetters(['getPatient','getPhone'])
  },
  methods:{
    //获取菜单
    getItem(){
      let data = [
        {icon:' iconfont icon-buchongbanli',sn:'1',menuName:'门诊病历',url:'/cliniclist'},
        {icon:' iconfont icon-gerenxinxi1',sn:'2',menuName:'患者列表',url:'/patientlist'},
      ];
      this.navItems = data;
      this.activeName1 = this.navItems[0].sn;
      
      let data1 = [
        {
          icon:'',sn:'1',
          menuName:'待诊列表',
          count:0,
          children:[
          ]
        },
        {
          icon:'',sn:'3',
          menuName:'今日就诊',
          count:0,
          children:[

          ]
        },
        {
          icon:'',sn:'2',
          menuName:'历史病历',
          count:0,
          children:[

          ]
        },
      ];
      this.navItems1 = data1;
      // console.log(this.navItems1);
    },
    //获取待诊就诊列表
    getList(diagnosisState){
      // console.log(diagnosisState);
      let _this = this;
      clinicalList({
        diagnosisState:diagnosisState
      }).then(res => {
        console.log(res);
        // console.log(this.navItems1)
        switch(diagnosisState){
          case 1:
            let todArr = [];
            for(let i=0;i<res.length;i++){
              let obj = {
                icon:'',
                sn:'',
                name:'',
                mobile:''
              };
              obj.name = res[i].name;
              obj.sn = res[i].id;
              obj.mobile = res[i].mobile;
              todArr.push(obj);
            }
            this.navItems1[0].children = todArr;
            this.navItems1[0].count = res.length;
            break;
          case 3:
            let waitArr = [];
            for(let i=0;i<res.length;i++){
              let obj = {
                icon:'',
                sn:'',
                name:'',
                mobile:'',
                hospitalCaseId:0
              };
              obj.name = res[i].name;
              // obj.sn = res[i].id;
              obj.mobile = res[i].mobile;
              obj.hospitalCaseId = res[i].hospitalCaseId;
              waitArr.push(obj);
            }
            this.navItems1[1].children = waitArr;
            this.navItems1[1].count = res.length;
            // console.log(waitArr);
            break;
        }
        // console.log(this.navItems1)
      });
    },
    //历史病历
    historyList(name,phone){
      historyList({
        name:name,
        phone:phone
      }).then(res=>{
        // console.log(res);
        let historyArr = [];
        for(let i=0;i<res.length;i++){
          let obj = {
            icon:'',
            sn:'',
            name:'',
            mobile:'',
            diagnosis:'',
            diagnosisTime:''
          };
          obj.name = res[i].name;
          obj.sn = res[i].id;
          obj.mobile = res[i].mobile;
          obj.diagnosis = res[i].diagnosis;
          obj.diagnosisTime = res[i].diagnosisTime;
          historyArr.push(obj);
        }
        // console.log(historyArr);
        
        this.navItems1[2].children = historyArr;
        this.navItems1[2].count = res.length;
      });
    },
    //选择患者
    changePatient(id,hospitalCaseId,diagnosisState){
      // console.log(id);
      // console.log(hospitalCaseId)
      // console.log(diagnosisState);
      switch(diagnosisState){
        case '1':
          this.$router.push({path:'/cliniclist',query:{editId:id}});
          this.reload();
          break;
        case '3':
          this.$router.push({path:'/cliniclist',query:{hospitalCaseId:hospitalCaseId}});
          this.reload();
          break;
        case '2':
          this.$router.push({path:'/cliniclist',query:{historyId:id}});
          this.reload();
          break;
      }
    },
    //加载常用疾病和症状和推广项目
    getCommom(){
      let _this = this;
      commonDisease().then(res=>{
        // console.log(res);
        this.comDisease = res;
      });
      commonSymptom({
        name:''
      }).then(res=>{
        // console.log(res);
        let arr = [];
        res.forEach(item => {
          let obj = {
            name:'',
            isSel:false
          };
          obj.name = item.name;
          arr.push(obj);
          this.comSymptom = arr;
        });
        // console.log(arr);
      });

      expansionPro().then(res=>{
        console.log(res);
        let data = res.data;
        console.log(data);
        // this.comInspection = data;
        let arr = [];
        data.forEach(item => {
          let obj = {
            hospitalProjectName: item.hospitalProjectName,
            id: item.id,
            name: item.name,
            price: item.price,
            isSel:false
          };
          arr.push(obj);
          this.comInspection = arr;
          
        });
        this.$store.commit('setExpandName',this.comInspection);
        console.log(this.comInspection);
      });
    },
    //选择疾病
    selectDisease(disease){
      this.$store.state.sickName = '';
      this.$store.state.expandName = '';
      this.$store.commit('setSick',disease.name); 
      // this.$store.commit('setType',0);
      console.log(this.$store.state.sickName);
    },
    //选择症状
    selectSymptom(symptom){
      this.$store.state.sickName = '';
      this.$store.state.expandName = '';
      let arr = [];
      arr = this.symptomStr;
      let index = this.symptomStr.findIndex(item=>item===symptom.name);
      if(symptom.isSel){
        symptom.isSel = false;
        arr.splice(index,1);
      }else{
        symptom.isSel = true;
        if(index==-1){
          arr.push(symptom.name);
        }
      }
      this.symptomStr = arr;
      console.log(this.symptomStr);
      let keyWord = '';
      keyWord = this.symptomStr.join(',');
      console.log(keyWord);
      
      this.$store.commit('setSick',keyWord);
      // console.log(this.$store.state.sickName);
    },
    //选择项目
    selectInspection(inspection,comInspection){
      console.log(inspection);
      console.log(this.comInspection);
      
      this.$store.state.sickName = '';
      this.$store.state.expandName = '';
      let arr = [];
      arr = this.inspectStr;
      // let index = this.inspectStr.findIndex(item=>item===inspection.id);
      // console.log(index);
      if(inspection.isSel){
        inspection.isSel = false;
      }else{
        inspection.isSel = true;
      }
      this.inspectStr = this.comInspection;
      // console.log(this.inspectStr);
      console.log(this.comInspection);
      this.$store.commit('setExpandName',this.inspectStr);
      // console.log(this.$store.state.expandName);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.clinic{
  height: 100%;
  overflow: scroll;
}
.ivu-menu>li>ul{
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap row;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
    height: inherit;
    line-height: inherit;
    border: none;
    margin-right: 30px;
    /* color: #515a6e; */
}
/* 底部边框 */
.ivu-menu-horizontal.ivu-menu-light:after {
    content: '';
    display: block;
    width: 100%;
    height: 0px;
    background: #dcdee2;
    position: absolute;
    bottom: 0;
    left: 0;
}
.ivu-menu-item{
  font-size: 14px;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    color: #fff;
    border: none;
    background-color: #1955A8;   
}
.clinic /deep/.ivu-menu-vertical .ivu-menu-submenu-title {
  width: 100%;
  padding: 14px 24px;
  position: relative;
  cursor: pointer;
  z-index: 1;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.main{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  overflow-y: hidden;
}
.leftMain{
  width: 78%;
  /* overflow: scroll; */
  height: 100%;
  /* padding-bottom: 22px; */
}
.rightMain{
  width: 22%;
  padding: 0 10px 40px;
  /* padding-left: 10px; */
  overflow: scroll;
  height: 100%;
  /* padding-bottom:40px; */
}
.rightMain>ul.ivu-menu{
  border-radius: 10px;
  border: 1px solid #c9c9c9;
  padding: 5px;
  background-color: #fff;
}
.commonBox{
  padding: 10px 0;
}
.commonBox>div{
  border-radius: 10px;
  border:1px solid #c9c9c9;
  padding: 5px;
  margin-bottom: 10px;
  background-color: #fff;
}
.commonBox>div>p{
  font-weight: bold;
  font-size: 14px;
}
.commonBox>div>ul{
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap row;
}
.commonBox>div>ul>li{
  border-radius: 10px;
  border:1px solid #c9c9c9;
  padding: 5px;
  margin:5px 5px;
  font-size: 12px;
  cursor: pointer;
}
.commonBox>div>ul>li.hight{
  color: #fff;
  background-color: #1955A8;
}
.commonBox>div>ul>li:hover{
  color: #fff;
  background-color: #1955A8;
}
.commonBox>.inspection>ul{
  width: 100%;
}
.commonBox>.inspection>ul>li{
  width: 100%;
}
::-webkit-scrollbar {
    width: 14px;
    height: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/clinic/Clinic.vue